"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _FormField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./FormField.css") : void 0);
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-form-field';
var FormFieldDecorator = function FormFieldDecorator(_props) {
  var _decorator$props;
  var getChildPropsFromContext = (0, _AddChildPropsContext.useAddChildProps)();
  var props = getChildPropsFromContext ? _objectSpread(_objectSpread({}, _props), getChildPropsFromContext(FormFieldDecorator, _props)) : _props;
  var children = props.children,
    className = props.className,
    decoratorId = props.decoratorId,
    disabled = props.disabled,
    position = props.position,
    readOnly = props.readOnly,
    showInReadOnlyMode = props.showInReadOnlyMode,
    size = props.size;
  var isInputDecorator = position === 'inputStart' || position === 'inputEnd';
  if (readOnly && isInputDecorator && !showInReadOnlyMode) return null;
  var classnames = _bind.default.bind(_FormField.default);
  var addChildProps = function addChildProps(childComponent, childProps) {
    var childClassName = childProps.className,
      childControlProps = childProps.controlProps,
      childDisabled = childProps.disabled,
      forceSize = childProps.forceSize,
      childInputProps = childProps.inputProps,
      childReadOnly = childProps.readOnly;
    var disabledValue = disabled || childDisabled;
    if (childComponent.displayName === 'Button' && isInputDecorator) {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__button")),
        disabled: disabledValue,
        size: size,
        type: 'secondary'
      };
    }
    if (childComponent.displayName === 'Icon') {
      var iconSizeMap = {
        lg: 'sm',
        md: 'sm-minus'
      };
      return {
        size: forceSize || iconSizeMap[size]
      };
    }
    if (childComponent.displayName === 'InfoLabel') {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__info-label")),
        size: size
      };
    }
    if (childComponent.displayName === 'MultiComboBoxTokenizer') {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__tokenizer")),
        disabled: disabledValue,
        readOnly: readOnly
      };
    }
    if (childComponent.displayName === 'Select') {
      var _context;
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__select")),
        controlProps: _objectSpread(_objectSpread({}, childControlProps), {}, {
          className: classnames(childControlProps === null || childControlProps === void 0 ? void 0 : childControlProps.className, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__select-control"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__select-control--")).call(_context, size), size !== 'lg'))
        }),
        inputProps: _objectSpread(_objectSpread({}, childInputProps), {}, {
          className: classnames(childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.className, _constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__select-input"))
        }),
        disabled: disabledValue,
        readOnly: readOnly,
        size: size
      };
    }
    return {
      disabled: disabled || childDisabled,
      readOnly: readOnly || childReadOnly
    };
  };
  var decorator = /*#__PURE__*/_react.default.isValidElement(children) ? _react.default.Children.only(children) : /*#__PURE__*/_react.default.createElement("span", {
    id: decoratorId
  }, children);
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps
  }, /*#__PURE__*/_react.default.cloneElement(decorator, {
    className: classnames(className, decorator === null || decorator === void 0 || (_decorator$props = decorator.props) === null || _decorator$props === void 0 ? void 0 : _decorator$props.className)
  }));
};
FormFieldDecorator.displayName = 'FormFieldDecorator';
FormFieldDecorator.propTypes = {
  children: _propTypes.default.node.isRequired,
  position: _propTypes.default.string.isRequired,
  decoratorId: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  showInReadOnlyMode: _propTypes.default.bool,
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES)
};
var _default = exports.default = FormFieldDecorator;